import { call } from '../functions/call';
import { fromEntries } from './fromEntries';
import { isNativeObject } from './isNativeObject';

interface ObjectType {
    [key: string]: any;
}

interface DotObjectOptions<T = any> {
    separator?: string;
    transformer?: (value: T, key: string) => T;
}

export const flattenObject = <V = any>(object: any, options: DotObjectOptions<V> = {}): { [key: string]: V } => {
    if (!object || typeof object !== 'object' || isNativeObject(object)) {
        return object as any;
    }

    const newObject = {};
    const options$: DotObjectOptions<V> = {
        separator: '.',
        transformer: (value: V): V => value,
        ...(options as any),
    };

    const __setter = (key: string, value: any): void => {
        newObject[key] = call(options$.transformer, value, key);
    };

    const __flatten = (obj: ObjectType, path = ''): any => {
        // $FlowFixMe
        if (obj && obj.toJS && typeof obj.toJS === 'function') {
            obj = obj.toJS();
        }

        // $FlowFixMe
        if (obj && obj instanceof Map) {
            obj = fromEntries(obj.entries());
        }

        // $FlowFixMe
        if (obj && obj instanceof Set) {
            // $FlowFixMe
            obj = Array.from(obj);
        }

        if (obj && typeof obj === 'object') {
            if (isNativeObject(obj)) {
                __setter(path, obj);
            } else {
                Object.entries(obj).forEach(([key, value]) => {
                    const keyPath = [path, key].filter((v) => !!v).join(options$.separator);

                    if (typeof value !== 'object') {
                        __setter(keyPath, value);
                    } else {
                        __flatten(value as any, keyPath);
                    }
                }, {});
            }
        } else {
            __setter(path, obj);
        }
    };

    __flatten(object as any);

    return newObject;
};
